export class ProtectedResource {
  constructor(public route: string, public scopes: string[]) {}
}